import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderZaptrance from './HeaderZaptrance';
import ZaptranceSideNav from './ZaptranceSideNav';
import axios from 'axios';

import AddProgramModal from './modals/AddProgramModal';
import LayersIcon from '@mui/icons-material/Layers';

import FilterIcon from '@mui/icons-material/FilterListOutlined';

const itemsPerPage = 10;

const ZaptrancePrograms = () => {
  const navigate = useNavigate();

  const [programs, setPrograms] = useState([]);
  const [programTypes, setProgramTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(programs ? programs.length : 0);
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const openAddModal = () => {
    setIsAddModalOpen(true);
  };
  const closeAddModal = () => {
    setIsAddModalOpen(false);
  };

  const handleAddInstitution = (institutionName) => {
    closeAddModal();
    handleData();
  };

  const [searchQuery, setSearchQuery] = useState('');
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };
  const filteredPrograms = programs.filter((program) =>
  program.programName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  let token = localStorage.getItem('token');
  useEffect(() => {
    if (!token) {
      navigate('/');
    } else {
      handleData();
    }
  }, [navigate]);

  const handleData = async () => {
    setLoading(true);
    try {
      const response = await axios.get('https://gacsstage.zaptrance.ng/api/admin/programs', {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.success) {
        setPrograms(response.data.data);
        setTotalItems(response.data.data.length);
        setLoading(false);
        await getProgramTypes();
      } else {
        setLoading(false);
        console.error('Request failed:' + response.data.message);
      }
    } catch (error) {
      setLoading(false);
      console.error('Request error:'+ error);
    }
  };

  const getProgramTypes = async () => {
    try {
      const response = await axios.get('https://gacsstage.zaptrance.ng/api/admin/program_types', {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.success) {
        setProgramTypes(response.data.data);
        setLoading(false);
      } else {
        console.error('Request failed:' + response.data.message);
      }
    } catch (error) {
      console.error('Request error:'+ error);
    }
  };


  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentFilteredPrograms = filteredPrograms ? filteredPrograms.slice(indexOfFirstItem, indexOfLastItem) : [];
  let countPrograms = indexOfFirstItem + 1;

  return (
    <div className="content flex-grow">
        <div className="inner-content">
          <HeaderZaptrance />
          <div className="p-4" style={{ backgroundColor: '#F6F7FB' }}>
            <div className='text-black p-4 flex text-xl'>
              <div><LayersIcon className='mr-4'/></div>Programs
            </div>

            <div className="text-right">
              <button className="px-6 py-3 m-4"
                style={{
                  width: '200px',
                  backgroundColor: '#095918',
                  borderRadius: '8px',
                  padding: '10px 20px',
                  color: 'white',
                  border: 'none',
                }}
                onClick={openAddModal}
              >
                Add Program
              </button>
            </div>

            {loading ? (
              <div className="p-4">Loading...</div>
            ) : (
<div>
  
<div className="flex justify-between my-2 pb-2 ">
              <div className="flex items-center">
                <div className="text-xl">Programs List</div>
              </div>
              <div className="flex items-center">
                <input
                  type="text"
                  placeholder="Search"
                  className="border border-gray-300 rounded-lg py-1 px-2 mr-4"
                  onChange={handleSearchChange}
                />
                <div className="flex items-center">
                  <FilterIcon className="text-gray-500 cursor-pointer" />
                  <span className="text-gray-500 ml-1">Filter Search</span>
                </div>
              </div>
            </div>
            
              <div className="overflow-x-auto">
                <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
                  <thead>
                    <tr>
                      <th style={{backgroundColor: '#095918'}} className="px-6 py-3 border-b border-gray-300 text-left text-xs leading-4 font-medium text-white uppercase tracking-wider">
                        S/N
                      </th>
                      <th style={{backgroundColor: '#095918'}} className="px-6 py-3 border-b border-gray-300 text-left text-xs leading-4 font-medium text-white uppercase tracking-wider">
                        Program Type
                      </th>
                      <th style={{backgroundColor: '#095918'}} className="px-6 py-3 border-b border-gray-300 text-left text-xs leading-4 font-medium text-white uppercase tracking-wider">
                        Program Name
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentFilteredPrograms.map((program) => (
                      <tr key={program.id}>
                        <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
                          {countPrograms++} {/* {program.id} */}
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
                          {program.type.name}
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
                          {program.programName}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
</div>
            )}

            {/* Pagination Controls */}
            <div className="flex justify-center mt-4">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className="px-4 py-2 mr-2 bg-gray-300 hover:bg-nbteGreen hover:text-white transition-colors duration-300"
                style={{width: '100px', borderRadius: '30px'}}
              >
                Previous
              </button>
              <button
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                className="px-4 py-2 bg-gray-300 hover:bg-nbteGreen hover:text-white transition-colors duration-300"
                style={{width: '100px', borderRadius: '30px'}}
              >
                Next
              </button>
            </div>

            <AddProgramModal
              isOpen={isAddModalOpen}
              onRequestClose={closeAddModal}
              onAddProgram={handleAddInstitution}
              programTypes={programTypes}
            />

          </div>
        </div>
      </div>
  );
};

export default ZaptrancePrograms;
